const brands = ["Adobe", "Shopify", "Notion", "OpenAI", "Canva"];

export const TrustBar = () => (
  <section data-testid="trust-bar-section" className="relative py-14 border-y border-white/5 overflow-hidden">
    <p className="text-center text-[10px] uppercase tracking-[0.35em] text-slate-600 mb-8 px-4">
      Trusted by teams & creators behind
    </p>
    <div className="marquee-mask overflow-hidden">
      <div className="animate-marquee flex w-max items-center gap-20 pr-20">
        {[...brands, ...brands, ...brands, ...brands].map((b, i) => (
          <span
            key={`${b}-${i}`}
            data-testid={i < brands.length ? `trust-logo-${b.toLowerCase()}` : undefined}
            className="font-display text-2xl sm:text-3xl font-medium text-slate-600 hover:text-slate-200 transition-colors duration-500 whitespace-nowrap select-none"
            style={{ opacity: 0.55 + (i % brands.length) * 0.08 }}
          >
            {b}
          </span>
        ))}
      </div>
    </div>
  </section>
);
